"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("./");
const react_2 = require("@osmosys/react");
function CreateResourceModalForm(props) {
    const { header, formProps, fields, disabled, isOpen, onToggle, hideName, } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysModal, { osysName: "CreateResourceModalForm", isOpen: !!isOpen, centered: true, toggle: () => {
                onToggle(false);
            } },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => {
                    onToggle(false);
                } }, header),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement(reusables_1.Form, Object.assign({}, formProps), (formikProps, result) => (react_1.default.createElement(react_1.default.Fragment, null,
                    !hideName && react_1.default.createElement(reusables_1.FormGroup, { name: "name", label: "Name" }),
                    fields,
                    react_1.default.createElement(reusables_1.AjaxButton, { type: "submit", color: "success", className: "w-100", icon: pro_solid_svg_icons_1.faPlus, label: "Create", error: result.error, loading: result.loading, success: !!result.data, onClick: () => formikProps.handleSubmit(), disabled: result.loading || disabled }),
                    react_1.default.createElement(react_2.OsmosysErrorAlert
                    // marginTop
                    // marginBottom={false}
                    // dismissable
                    , { 
                        // marginTop
                        // marginBottom={false}
                        // dismissable
                        apolloError: result.error }))))))));
}
exports.CreateResourceModalForm = CreateResourceModalForm;
//# sourceMappingURL=CreateResourceModalForm.js.map